#import '../../fragments/userProfile.fragment.graphql'

mutation addItemsToCart($items: [ShoppingCartItemInput], $updateOnly: Boolean) {
  addItemsToCart(input: { items: $items, updateOnly: $updateOnly }) {
    userProfile {
      ...UserProfileFragment
    }
  }
}
